// Starting book used when a tenant has no exchange-rate document.
// Internal value / external value. HKD is the base currency.
export const DEFAULT_EXCHANGE_RATES = [
  { code: "HKD", value: 1, externalValue: 1 },
  { code: "USD", value: 7.75, externalValue: 7.8 },
  { code: "RMB", value: 1.1, externalValue: 1.13 },
  { code: "AUD", value: 5, externalValue: 5.2 },
  { code: "SGD", value: 5.55, externalValue: 5.8 },
];

const copyRates = (rates) =>
  rates.map((row) => ({
    code: row.code,
    value: row.value,
    externalValue: row.externalValue,
  }));

export function resolveExchangeRateForm(docs) {
  const list = Array.isArray(docs) ? docs : [];
  const existing = list.find((doc) => doc?.active) || list[0];

  if (!existing) {
    return {
      mode: "add",
      data: {
        active: true,
        rates: copyRates(DEFAULT_EXCHANGE_RATES),
      },
    };
  }

  return {
    mode: "edit",
    id: existing._id,
    data: {
      ...existing,
      active: true,
      rates: Array.isArray(existing.rates) ? existing.rates : [],
    },
  };
}
